import { ElementSource } from "chq";
import { Preview } from "@creatomate/preview";
import { getSubdomain } from "app/utils";
import { VIDEO_TYPE } from "../constants";

const getStoryElements = async (preview: Preview, videos: File[], track: number) => {
  const storyElements = [];
  for (let i = 0; i < videos.length; i += 1) {
    const media = videos[i];
    const sourceUrl = `https://${getSubdomain()}.culturehq.com/${Date.now()}`;
    const fileUrl = URL.createObjectURL(media);
    // eslint-disable-next-line no-await-in-loop
    await preview.cacheAsset(sourceUrl, media);
    const name = `media-${media.name}-fileUrl-${fileUrl}`;

    storyElements.push({
      type: VIDEO_TYPE,
      name,
      track,
      source: sourceUrl,
      fit: "contain",
      width: "100%"
    });
  }

  return storyElements;
};

const loadAddedVideosInJson = async (
  mediaData: Record<string, any>,
  selectedVideos: any[],
  preview: Preview
): Promise<Record<string, any>> => {
  const videoElements = mediaData.elements.filter(
    (element: ElementSource) => element.type === VIDEO_TYPE
  );
  const lastVideo = videoElements.sort(
    (a: ElementSource, b: ElementSource) => a.time - b.time)[videoElements.length - 1];

  const existingVideosCount = videoElements.length - 1;
  const videosToAdd = selectedVideos.filter((_, index) => index > existingVideosCount);
  const storyElements = await getStoryElements(preview, videosToAdd, lastVideo.track);
  return {
    ...mediaData,
    elements: [...(mediaData.elements), ...storyElements]
  };
};

export default loadAddedVideosInJson;
